import { ApiService } from '../../../ApiService';

export interface AvailableStage {
  id: number;
  name: string;
  isFirst: boolean;
  isHired: boolean;
}

export interface AvailableStagesResult {
  stages: AvailableStage[];
}

export class AvailableStagesService {
  public static list(
    params: {
      filterBy: string;
      filterByIds: string[];
    },
    signal?: AbortSignal,
  ): Promise<AvailableStagesResult> {
    return ApiService.get(
      '/api/v1/applicant_tracking/analytics/available_stages',
      {
        filter_by: params.filterBy,
        filter_by_ids: params.filterByIds,
      },
      { signal },
    );
  }
}
